import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Response, Headers } from '@angular/http';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { ConfiguracaoVisual } from '../modelo/configuracaoVisual';

@Injectable()
export class ConfiguracaoVisualService {

    constructor(private restClient: RestClientService) {

    }

    recuperarConfiguracaoCliente = (nuCpfCnpj: string) : Observable<ConfiguracaoVisual> => {
        let resourcePath = Config.CONFIG_VISUAL_PATH + "/recuperarConfiguracaoCliente";
        resourcePath += "/nuCpfCnpj/" + nuCpfCnpj;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarConfiguracaoParceiro = (cdParceiro: number) : Observable<ConfiguracaoVisual> => {
        let resourcePath = Config.CONFIG_VISUAL_PATH + "/recuperarConfiguracaoParceiro";
        resourcePath += "/cdParceiro/" + cdParceiro;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/configuracaoVisual.service.ts